import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid, Text } from '@factorialco/deprecated-design-system'
import AgreementImage from 'assets/images/contract_agreement.svg'
import InsightsImage from 'assets/images/contract_insights.svg'
import { ContractVersionsPageEmployeeFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  employee: ContractVersionsPageEmployeeFragment
  canEditContracts?: boolean
}

const BlankSlate = ({ employee, canEditContracts }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onCreateContractClick = () => {
    navigate(
      navigation.employees.id.contractVersions.update.fullPath({
        id: employee.id.toString(),
      })
    )
  }

  return (
    <Box paddingY="s48">
      <Grid variant="fixed">
        <Box
          gridColSpan={{ xxs: 10 }}
          style={{ gridColumnStart: '2', gridColumnEnd: 'span 10' }}
          borderRadius={{ all: 'abs008' }}
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
          justifyContent="center"
          alignItems="center"
          gap="s48"
          paddingY="s120"
        >
          <Text.Header2 color="grey1000">
            {i18n.t('contract_versions.blank_slate.new.title', {
              fullName: employee.fullName,
            })}
          </Text.Header2>
          <Box gap="s40" justifyContent="center" alignItems="center">
            <Box flexDirection="row" gap="s64">
              <Item
                image={AgreementImage}
                description={i18n.t('contract_versions.blank_slate.new.items.agreement', {
                  fullName: employee.firstName,
                })}
              />
              <Item
                image={InsightsImage}
                description={i18n.t('contract_versions.blank_slate.new.items.insights')}
              />
            </Box>
            <Text.Normal size="200" weight="medium" color="grey800">
              {i18n.t('contract_versions.blank_slate.new.description')}
            </Text.Normal>
            {canEditContracts && (
              <Button onClick={() => onCreateContractClick()} type="primary" iconName="add">
                {i18n.t('contract_versions.blank_slate.new.button')}
              </Button>
            )}
          </Box>
        </Box>
      </Grid>
    </Box>
  )
}

export default BlankSlate
